import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./img/2.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = (selectLang) => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = (type) => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            class="cls-2"
            points="231.82 267.87 235.59 264.11 235.59 264.11 232.91 261.44 225.16 253.68 224.81 254.03 224.77 253.99 221.33 257.43 221.83 257.93 212.79 266.96 212.64 266.81 208.24 271.21 208.41 271.39 206.75 273.05 224.28 290.57 239.4 275.45 231.82 267.87"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="176.2 212.25 179.96 208.49 179.96 208.49 177.29 205.81 169.53 198.06 169.18 198.4 169.15 198.36 165.71 201.8 166.2 202.3 157.17 211.33 157.02 211.18 152.61 215.59 152.79 215.76 151.13 217.42 168.65 234.94 183.77 219.82 176.2 212.25"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="119.37 227.4 115.61 231.16 115.61 231.16 118.28 233.84 126.04 241.59 126.39 241.25 126.42 241.28 129.86 237.84 129.37 237.35 138.4 228.32 138.55 228.46 142.96 224.06 142.78 223.89 144.44 222.23 126.92 204.71 111.8 219.83 119.37 227.4"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="362.24 172.88 358.48 169.12 358.48 169.12 355.81 171.79 348.05 179.55 348.39 179.89 348.36 179.93 351.8 183.37 352.29 182.88 361.32 191.91 361.18 192.06 365.58 196.46 365.75 196.29 367.41 197.95 384.93 180.43 369.81 165.3 362.24 172.88"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="306.64 228.47 302.88 224.71 302.88 224.71 300.21 227.38 292.45 235.14 292.8 235.49 292.76 235.53 296.2 238.97 296.69 238.47 305.73 247.5 305.58 247.65 309.99 252.06 310.16 251.89 311.82 253.54 329.34 236.02 314.22 220.9 306.64 228.47"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="377.33 229.79 381.1 233.56 381.1 233.56 383.77 230.88 391.53 223.13 391.18 222.78 391.22 222.74 387.78 219.3 387.28 219.8 378.25 210.76 378.4 210.62 373.99 206.21 373.82 206.38 372.16 204.72 354.64 222.25 369.76 237.37 377.33 229.79"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            class="cls-2"
            points="137.43 231.15 130.28 238.31 129.82 237.85 123.06 244.6 130.99 252.53 127.63 255.9 138.26 266.53 148.43 256.36 147.9 255.83 162.97 240.75 145.27 223.06 139.21 229.12 139.36 229.27 137.45 231.18 137.43 231.15"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="346.21 215.87 347.87 217.52 330.35 235.04 315.25 219.95 315.07 220.12 311.27 216.32 313.7 213.89 314.06 214.26 329.36 198.96 341.85 211.46 342.05 211.26 346.43 215.65 346.21 215.87"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="290.58 271.49 292.24 273.15 274.72 290.67 259.62 275.57 259.45 275.75 255.65 271.95 258.07 269.52 258.44 269.88 273.73 254.59 286.23 267.09 286.42 266.89 290.8 271.27 290.58 271.49"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="188.85 251.84 187.19 253.5 169.67 235.98 184.77 220.88 184.59 220.71 188.4 216.91 190.82 219.33 190.46 219.7 205.75 234.99 193.26 247.49 193.45 247.68 189.07 252.06 188.85 251.84"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="133.28 196.28 131.63 197.94 114.11 180.41 129.2 165.32 129.03 165.14 132.83 161.34 135.26 163.77 134.89 164.13 150.19 179.42 137.69 191.92 137.88 192.12 133.5 196.5 133.28 196.28"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="366.49 199 348.87 216.63 330.36 198.11 330.2 198.27 326.42 194.48 328.8 192.1 329.19 192.5 344.51 177.18 360.35 193.01 360.55 192.82 364.98 197.25 364.86 197.37 366.49 199"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="310.95 254.54 293.33 272.16 274.82 253.65 274.67 253.8 270.88 250.02 273.26 247.64 273.66 248.03 288.98 232.71 304.81 248.55 305.01 248.35 309.44 252.78 309.32 252.91 310.95 254.54"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="205.73 272.18 188.11 254.56 206.62 236.04 206.47 235.89 210.25 232.1 212.64 234.49 212.24 234.88 227.56 250.2 211.72 266.04 211.92 266.24 207.49 270.67 207.37 270.54 205.73 272.18"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="150.2 216.65 132.58 199.03 151.09 180.51 150.94 180.36 154.72 176.57 157.11 178.96 156.71 179.35 172.03 194.67 156.19 210.51 156.39 210.71 151.96 215.14 151.84 215.01 150.2 216.65"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="335.97 240.73 353.59 223.11 372.1 241.62 372.25 241.47 376.04 245.25 373.66 247.63 373.26 247.24 357.95 262.56 342.11 246.72 341.91 246.92 337.48 242.49 337.6 242.36 335.97 240.73"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="235.62 324.03 235.62 302.62 224.78 302.62 219.52 297.36 201 315.89 209.12 324 209.12 328.78 221.99 328.78 221.99 329.28 225.82 329.28 225.82 324.06 235.62 324.03"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            class="cls-2"
            points="315.49 275.94 308.21 268.66 335.1 241.77 336.73 243.39 336.85 243.26 339.94 246.36 339.84 246.46 350.27 256.89 350.72 256.44 354.43 260.15 335.38 279.21 331.66 275.5 323.25 283.91 315.38 276.05 315.49 275.94"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="208.92 305.79 199.19 315.51 190.93 307.25 187.49 310.69 168.43 291.63 175.58 284.48 175.98 284.88 191.14 269.72 218.06 296.64 216.39 298.31 216.56 298.48 209.08 305.95 208.92 305.79"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="289.62 305.54 299.35 315.26 307.61 307 311.05 310.44 330.11 291.38 322.96 284.23 322.56 284.63 307.4 269.47 280.48 296.39 282.15 298.06 281.99 298.23 289.46 305.7 289.62 305.54"
            fill="#231f20"
          />
          <polygon
            class="cls-2"
            points="148.69 256.77 144.91 260.55 172.03 287.68 181.47 278.24 181.38 278.14 190.83 268.69 163.95 241.81 162.28 243.48 162.13 243.34 151.34 254.12 151.47 254.25 148.82 256.9 148.69 256.77"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(244 160)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            2 楼
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(226 160)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            2-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(234 160)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            2nd Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/a/2.js